function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000005256448925136084890000014134633585104009103_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1.5,0h12.9C15.3,0,16,0.7,16,1.5v12.9c0,0.8-0.7,1.5-1.5,1.5H1.5C0.7,16,0,15.3,0,14.5V1.5C0,0.7,0.7,0,1.5,0 z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M10,5.2c0.2,0,0.4,0.2,0.4,0.4v4.3v1.3l-0.6-0.5l-0.6,0.5l-0.6-0.5L8,11.2l-0.6-0.5l-0.6,0.5l-0.6-0.5 l-0.6,0.5V5.6c0-0.2,0.2-0.4,0.4-0.4H10z M8,6.8c0.2,0,0.4-0.2,0.4-0.4S8.2,6,8,6S7.6,6.2,7.6,6.4S7.8,6.8,8,6.8z"
});

var SvgKds = function SvgKds(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    width: 16,
    height: 16,
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.013,
    y1: 10,
    x2: 15.987,
    y2: 10,
    gradientTransform: "matrix(1 0 0 -1 0 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34CB9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CB68D"
    }
  })), _ref3, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056400923493421995550000011859284377310632126_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8575,
    y1: 10.0001,
    x2: 2.1424,
    y2: 10.0001,
    gradientTransform: "matrix(1 0 0 -1 0 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34CB9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CB68D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056400923493421995550000011859284377310632126_)"
    },
    d: "M8,13.9c3.2,0,5.9-2.6,5.9-5.9 c0-3.2-2.6-5.9-5.9-5.9C4.8,2.1,2.1,4.8,2.1,8C2.1,11.2,4.8,13.9,8,13.9z"
  }), _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kds.a4dd1e6d.svg";
export { ForwardRef as ReactComponent };